import { useMutation, useQueryClient } from "@tanstack/react-query";

import { VerifierDetectionFeedback, decideFarmDetection } from "services";

import { DECIDE_FARM_DETECTION, GET_FARM_COVER_CROP_DETECTIONS, GET_FARM_MAIN_CROP_DETECTIONS } from "consts";

const DETECTIONS_QUERY_KEYS = { coverCrop: GET_FARM_COVER_CROP_DETECTIONS, mainCrop: GET_FARM_MAIN_CROP_DETECTIONS } as const;

// The verifier's Yes/No feedback on a detection. Refreshing its list brings the saved answer back the next time the drawer
// opens; it isn't awaited, so the buttons don't wait for it.
export const useDecideFarmDetection = ({ farmId, detectionType }: { farmId: string; detectionType: keyof typeof DETECTIONS_QUERY_KEYS }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [DECIDE_FARM_DETECTION, farmId],
    mutationFn: ({ detectionId, isCorrect }: VerifierDetectionFeedback) => decideFarmDetection({ farmId, detectionId, isCorrect }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DETECTIONS_QUERY_KEYS[detectionType], farmId] });
    },
  });
};
